export default "__VITE_ASSET__af3b237e__"